import { render, staticRenderFns } from "./VersionChecker.vue?vue&type=template&id=37fb925d&"
import script from "./VersionChecker.vue?vue&type=script&lang=js&"
export * from "./VersionChecker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports